<template>
  <div>
    <contnav :show="navshow" :screenwidth="screenWidth"></contnav>
    <div class="banner-outer">
      <!-- 轮播 -->
      <slot name="banner"></slot> 
      <img v-if="headerImg" class="headerImg" :src="headerImg" alt="headerImg" />
    </div>
    <!--内容 -->
    <main class="main">
      <slot></slot>
    </main>
    <!-- 底部内容 -->
    <contfooter :show="footershow"></contfooter>
  </div>
</template>

<script>
// import local from "../utils/local";
import contnav from "../components/Nav";
import contfooter from "../components/Footer";
import { view } from "../api/index";
export default {
  components: { contfooter, contnav },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      headerImg:"",
      footList:["business","solution","cases"]
    };
  },
  computed: {
    // 导航是否完整显示
    navshow: function () {
      return this.screenWidth >= 1030 ? true : false;
    },
    footershow: function () {
      return this.screenWidth >= 950 ? true : false;
    },
  },
  methods: {
    // 顶部图片
    async getHeaderImg(id) {
      let send = {
        url: {
          id,
        },
      };
      let res = await view(send);
      if (res.type == "success") {
        //判断显示的尺寸，来确定顶部的图片
        if(this.navshow){
        this.headerImg = this.$srcHandle(res.data.data.image_pc);
        }else{
        this.headerImg = this.$srcHandle(res.data.data.image_phone);
          
        }
      } else {
        console.log(res.msg);
      }
    },
    
  },
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          this.timer = false;
        }, 400);
      }
    },
  },
  mounted() {
    //原来
    // this.$map[this.$route.name] && this.getHeaderImg(this.$map[this.$route.name]);
    // zhl-----------------
    // this.$route.name == "home" ? local.set("localPath","") : local.set("localPath",local.get("prePath"))
    // this.$map[local.get("localPath")] && this.getHeaderImg(this.$map[local.get("localPath")]);
    // console.log(this.$map[this.$route.params.name],this.$route.params.name)
    
    if(this.$route.params.name){
      this.$map[this.$route.params.name] && this.getHeaderImg(this.$map[this.$route.params.name]);
    }else{
      this.$map[this.$route.name] && this.getHeaderImg(this.$map[this.$route.name]);
    }
    // ---------------------
    // console.log(this.$map)
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>

<style scoped lang="less">
// .main {
  // max-width: 1240px;
  // width: 80%;
  // margin: 6vw auto;
// }
.headerImg {
    width: 100%;
  }

@media screen and (min-width: 1200px) {
  .banner-outer {
    padding-top: 84px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  .banner-outer {
    padding-top: 84px;
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  .banner-outer {
    padding-top: 64px;
  }
}
@media screen and (max-width: 414px) {
  //phone
  .banner-outer {
    padding-top: 44px;
  }
}
</style>
